import React, { useEffect, useState, useRef } from 'react';
import JobAdderLogo from '../../images/jobAdder/jobAdderLogo.svg';
import axios from 'axios';
import { Button } from '../../fieldsComponents/appointments/button';


// If you have a shared Button component, import it. Otherwise, define a simple one below.
// import Button from '../../fieldsComponents/button';

function JobAdderPanel({ acctNo }) {
  // status: 'loading', 'connected', 'disconnected', 'reconnect', 'error'
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);
  const userEmail = localStorage.getItem('userEmail');
  const acctId = localStorage.getItem('acctId');
  const hasFetched = useRef(false);
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (!acctNo) return;
    setStatus('loading');
    const token = localStorage.getItem('token');
    // Use acctId from props, not localStorage

    console.log('JobAdderPanel acctId from props:', acctId);
    // No need to call setAcctId here; acctId comes from props/context
    if (!acctId) {
      setStatus('disconnected');
      return;
    }
    (async () => {
      try {
        const response = await fetch(`/api/jobadder/status/${acctId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        if (data) {
          if (data.connected === true || data.status === true) {
            setStatus('connected');
          } else if (data.hasToken === true) {
            setStatus('reconnect');
          } else {
            setStatus('disconnected');
          }
        } else {
          setStatus('disconnected');
        }
      } catch (err) {
        setStatus('error');
        setError('Failed to fetch JobAdder status.');
      }
    })();
  }, [acctNo]);

  const handleConnect = () => {
    if (!acctId) {
      console.error("acctId is missing");
      return;
    }

    window.location.href = `${process.env.REACT_APP_API_URL}/api/jobadder/oAuth2/redirect/${acctId}?email=${encodeURIComponent(userEmail)}`;
  };


  const handleDisconnect = () => {
    setStatus('loading');
    axios
      .post('/api/jobadder/disconnect', { acctId })
      .then(() => {
        setStatus('disconnected');
      })
      .catch(() => {
        setStatus('error');
        setError('Failed to disconnect from JobAdder.');
      });
  };

  if (!acctNo) {
    return <div className="p-4">No account selected.</div>;
  }
  if (!acctId && status !== 'loading') {
    return <div className="p-4 text-red-600">No account ID found for this account.</div>;
  }

  if (status === 'error') {
    return <div className="p-4 text-red-600">{error}</div>;
  }

  return (
    <div className="flex items-start justify-center min-h-[70vh]  pt-52">
      <div className="p-6 max-w-md w-full bg-white rounded-lg shadow-md">
        <div className="flex flex-col items-center justify-center">
          {/* JobAdder Logo */}
          <img src={JobAdderLogo} alt="JobAdder Logo" className="mb-10" style={{ width: 142, height: 24 }} />
          {/* Button logic for connect, disconnect, reconnect */}
          {status === 'connected' && (
            <Button
              color="red"
              onClick={handleDisconnect}
              disabled={status === 'loading'}
              style={{ minWidth: 150, height: 40 }}

              className="min-w-[150px] h-10"
            >
              {status === 'loading' ? (
                <span>
                  <svg className="animate-spin h-5 w-5 mr-2 inline-block text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Loading...
                </span>
              ) : 'Disconnect'}
            </Button>
          )}
          {status === 'disconnected' && (
            <Button
              color="green"
              onClick={handleConnect}
              disabled={status === 'loading'}
              style={{ minWidth: 150, height: 40 }}
              className="min-w-[150px] h-10"
            >
              {status === 'loading' ? (
                <span>
                  <svg className="animate-spin h-5 w-5 mr-2 inline-block text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Loading...
                </span>
              ) : 'Connect'}
            </Button>
          )}
          {status === 'reconnect' && (
            <>
              <Button
                color="yellow"
                onClick={handleConnect}
                disabled={status === 'loading'}
                style={{ minWidth: 150, height: 40, backgroundColor: '#facc15', color: '#fff', border: 'none' }}
                className="min-w-[150px] h-10 bg-yellow-400 hover:bg-yellow-500 text-white font-semibold"
              >
                {status === 'loading' ? (
                  <span>
                    <svg className="animate-spin h-5 w-5 mr-2 inline-block text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                    </svg>
                    Loading...
                  </span>
                ) : 'Reconnect'}
              </Button>
              {userEmail && (
                <div className="mt-2 text-gray-700 text-center">
                  <span className="font-semibold">{userEmail}</span>
                </div>
              )}
            </>
          )}
          {/* Display user email below the button */}
          {status === 'connected' && userEmail && (
            <div className="mt-2 text-gray-700 text-center">
              <span className="font-semibold">{userEmail}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default JobAdderPanel;
